import { createFileRoute, redirect } from '@tanstack/react-router';
import AgencyDetailClient from '@/app/agencies/[id]/agency-detail-client';
import { getSessionJwt } from '@/services/auth';

export const Route = createFileRoute('/agencies/$agencyId')({
  component: AgencyDetail,
  beforeLoad: () => {
    if (!getSessionJwt()) {
      throw redirect({ to: '/login' });
    }
  },
});

function AgencyDetail() {
  const { agencyId } = Route.useParams();
  return <AgencyDetailClient agencyId={agencyId} />;
}
